import * as yup from 'yup';

export const schema = yup.object().shape({
  title: yup.string().required('Obrigatório'),
  body: yup.string().required('Obrigatório'),
  direction: yup.string(),
});
